export const SEO_DEFAULT: any = {
    type: 'website',
    title:
        'Báo Mới - Tin tức nóng nhất, tin tức mới nhất cập nhật liên tục 24H',
    ogTitle:
        'Báo Mới - Tin tức nóng nhất, tin tức mới nhất cập nhật liên tục 24H',
    description:
        'Báo Mới - Trang tin tự động cập nhật các tin tức Việt Nam và thế giới từ các báo và trang tin điện tử hàng đầu',
    keywords:
        'báo mới, baomoi, bao moi, tin tức, tin tuc, tổng hợp tin tức, cập nhật, báo điện tử, mới, nóng, nhanh, hot, Việt Nam, thế giới, biển đông, hà nội, tp hcm, sài gòn, xã hội, văn hóa, kinh tế, khoa học, công nghệ, thể thao, bóng đá, giải trí, pháp luật, giáo dục, sức khỏe, ô tô, xe máy, nhà đất.',
    robots: 'noarchive',
    googlebot: 'noarchive',
    url: '/',
    ogUrl: '/',
    imageUrl: 'https://baomoi-static.bmcdn.me/web/styles/img/facebook-thumb.png',
    imageWidth: '560',
    imageHeight: '292',
    ogSiteName: '',
    canonicalUrl: '/'
};

export const JSON_LD_DEFAULT: any = {
    name: 'Báo Mới - Tin tức nóng nhất, tin tức mới nhất cập nhật liên tục 24H',
    alternateName:
        'Báo Mới - Trang tin tự động cập nhật các tin tức Việt Nam và thế giới từ các  báo và  trang tin điện tử hàng đầu',
    url: 'https://baomoi.com',
    '@context': 'http://schema.org',
    '@type': 'WebSite',
};
